import SortTable from '../libs/sort_table';
// import FreezeTable from 'jquery-freeze-table'

class TableService {
  constructor() {
    this._containerId = 'data-table-container';
    this._frozenTableColumns = 1; // Number of frozen left table columns
  }

  get frozenTableColumns() {
    return this._frozenTableColumns;
  }

  createTable(headerData, bodyData) {
    let html = '<table id="data-table" class="table js-sort">';

    html += '<thead></thead>';
    html += '<tbody></tbody>';
    html += '</table>';

    document.getElementById(this._containerId).innerHTML = html;

    this.updateTableHeader(headerData);
    this.updateTableBody(bodyData);

    // $(`#${this._containerId}`).freezeTable({
    //   'columnNum' : this._frozenTableColumns,
    //   'freezeHead': true,
    //   'fixedNavbar': '#header'
    // })
  }

  updateTable(bodyData, headerData) {
    if (headerData) {
      this.updateTableHeader(headerData);
    }

    if (bodyData) {
      this.updateTableBody(bodyData);
    }

    this.updateTableFreeze();
  }

  updateTableFreeze() {
    // $(`#${this._containerId}`).freezeTable('update')
  }

  updateTableHeader(headerData) {
    let header = document.querySelector(`#${this._containerId} table thead`);
    let html = '';

    headerData.forEach((content, columnIndex) => {
      let frozen = columnIndex < this._frozenTableColumns ? 'frozen' : '';

      html += `<th class="${frozen}" data-controller="sort" data-action="click->sort#sortTable"><div><span>${content}</span><span> </span></div></th>`;
    });

    header.innerHTML = html;
  }

  updateTableBody(bodyData) {
    let body = document.querySelector(`#${this._containerId} table tbody`);
    let html = '';

    bodyData.forEach((data) => {
      html += '<tr>';

      data.forEach((content) => {
        if ([null, 'n', 'n/a'].includes(content)) {
          content = '-';
        } else if (['y', 'yes', 'x', 'X'].includes(content)) {
          content = '✓';
        }

        // It's getting even more hacky
        if (typeof content == 'string') {
          content = content.replace('NBI y', '<strong>NBI ✓</strong>');
          content = content.replace('NBI n', 'NBI -');
          content = content.replace('TXI y', '<br><strong>TXI ✓</strong>');
          content = content.replace('TXI n', '<br>TXI -');
          content = content.replace('RDI y', '<br><strong>RDI ✓</strong>');
          content = content.replace('RDI n', '<br>RDI -');
        }


        html += `<td>${content}</td>`;
      });

      html += '</tr>';
    });

    body.innerHTML = html;
  }

  sortTable(columnIndex, direction) {
    // Sort both tables: The real AND the shadow one
    let tables = document.querySelectorAll('#data-table-container table');

    for (let table of tables) {
      if (direction) {
        SortTable(table, columnIndex, direction);
      } else {
        SortTable(table, columnIndex);
      }

      let headers = table.querySelectorAll('thead th');
      let sortDirection = table.classList.contains('js-sort-desc')
        ? 'desc'
        : 'asc';

      headers.forEach(function (cell, index) {
        cell.classList.remove('sort-active-asc');
        cell.classList.remove('sort-active-desc');

        if (columnIndex === index) {
          cell.classList.add(`sort-active-${sortDirection}`);
        }
      });
    }
  }
}

export let tableService = new TableService();
